module.exports = __webpack_public_path__ + "img/vertical-arrow.78d51941.svg";